import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import Home from "./pages/Home";
import Colleges from "./pages/Colleges";
import CollegeDetail from "./pages/CollegeDetail";
import Universities from "./pages/Universities";
import UniversityDetail from "./pages/UniversityDetail";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import Exams from "./pages/Exams";
import ExamDetail from "./pages/ExamDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import AuthorPage from "./pages/AuthorPage";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminEntity from "./pages/AdminEntity";
import AdminSubPages from "./pages/AdminSubPages";
import AuthCallback from "./pages/AuthCallback";
import { AuthProvider } from "./lib/AuthContext";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/colleges" element={<Colleges />} />
        <Route path="/colleges/:id" element={<CollegeDetail />} />
        <Route path="/universities" element={<Universities />} />
        <Route path="/universities/:id" element={<UniversityDetail />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/exams" element={<Exams />} />
        <Route path="/exams/:id" element={<ExamDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/author/:slug" element={<AuthorPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path=":entity/:parentId/subpages" element={<AdminSubPages />} />
        <Route path=":entity" element={<AdminEntity />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
        <Toaster />
      </HelmetProvider>
    </div>
  );
}

export default App;
